import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=140e0e6d&scoped=true&lang=pug"
import script from "./PrimaryButton.vue?vue&type=script&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140e0e6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('140e0e6d')) {
      api.createRecord('140e0e6d', component.options)
    } else {
      api.reload('140e0e6d', component.options)
    }
    module.hot.accept("./PrimaryButton.vue?vue&type=template&id=140e0e6d&scoped=true&lang=pug", function () {
      api.rerender('140e0e6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/buttons/PrimaryButton.vue"
export default component.exports